import { useState, useEffect } from 'react';
function decodeToken(token) {
  try {
    if (token.split(".").length !== 3 || typeof token !== "string") {
      return null;
    }
    var payload = token.split(".")[1];
    var padding = "=".repeat((4 - payload.length % 4) % 4);
    var base64 = payload.replace("-", "+").replace("_", "/") + padding;
    var decoded = JSON.parse(atob(base64));
    return decoded;
  } catch (error) {
    return null;
  }
}
function isTokenExpired(token) {
  var decodedToken = decodeToken(token);
  var result = true;
  if (decodedToken && decodedToken.exp) {
    var expirationDate = new Date(0);
    expirationDate.setUTCSeconds(decodedToken.exp);
    result = expirationDate.valueOf() < new Date().valueOf();
  }
  return result;
}
function useJwt(userJwt) {
  var _useState = useState(false),
    isExpired = _useState[0],
    setIsExpired = _useState[1];
  var _useState2 = useState(null),
    decodedToken = _useState2[0],
    setDecodedToken = _useState2[1];
  useEffect(function () {
    evaluateToken(userJwt);
  }, [userJwt]);
  var evaluateToken = function evaluateToken(token) {
    setDecodedToken(decodeToken(token));
    setIsExpired(isTokenExpired(token));
  };
  return {
    isExpired: isExpired,
    decodedToken: decodedToken,
    reEvaluateToken: evaluateToken
  };
}
export { decodeToken, isTokenExpired as isExpired, useJwt };